import CustomScroll from "@src/component/customScroll";
import { memo, useState } from "react";
import { Image, ImageViewer } from "antd-mobile";
interface Preview {
  url?: string
  show: boolean
}
const FileData = (props: any) => {
  const [showPreview, setShowPreview] = useState<Preview>({ url: undefined, show: false })
  const { userInfo } = props;

  const UrlImg = (url: string, id?: number) => {
    return <Image src={url} width={165} height={99} key={id} fit='cover' onClick={() => { setShowPreview({ url, show: true }) }} fallback={<div className="failIcon"><i /></div>} placeholder={<div className="failIcon"><i /></div>} />
  }
  return (<div className="page bottomFit FileData">
    <CustomScroll>
      {(userInfo?.idfUrl || userInfo?.idbUrl)&&<div className="file-box">
        <h2 className="dotted-line">申请人身份证</h2>
        <div className="file-list">
          {UrlImg(userInfo?.idfUrl)}
          {UrlImg(userInfo?.idbUrl)}
        </div>
      </div>}
      {(userInfo?.driveMainUrl || userInfo?.driveSecondUrl)&&<div className="file-box">
        <h2 className="dotted-line">申请人摩托车驾驶证</h2>
        <div className="file-list">
          {UrlImg(userInfo?.driveMainUrl)}
          {UrlImg(userInfo?.driveSecondUrl)}
        </div>
      </div>}
      {userInfo?.faceUrl&&<div className="file-box">
        <h2 className="dotted-line">申请人正脸照</h2>
        <div className="file-list">
          {UrlImg(userInfo?.faceUrl)}
        </div>
      </div>}
      {userInfo?.work&&<div className="file-box">
        <h2 className="dotted-line">工作证明{userInfo?.work?.length&&<span>已上传{userInfo?.work?.length}张</span>}</h2>
        <div className="file-list">
          {userInfo?.work?.map((_ele: { id: number; osskey: string; }) => (UrlImg(_ele.osskey, _ele.id)))}
        </div>
      </div>}
      {userInfo?.credit&&<div className="file-box">
        <h2 className="dotted-line">征信-人行征信电子版{userInfo?.credit?.length&&<span>已上传{userInfo?.credit?.length}张</span>}</h2>
        <div className="file-list">
          {userInfo?.credit?.map((_ele: { id: number; osskey: string; }) => (UrlImg(_ele.osskey, _ele.id)))}
        </div>
      </div>}
      {userInfo?.flow&&<div className="file-box">
        <h2 className="dotted-line">近6个月工资（经营）流水{userInfo?.flow?.length&&<span>已上传{userInfo?.flow?.length}张</span>}</h2>
        <div className="file-list">
          {userInfo?.flow?.map((_ele: { id: number; osskey: string; }) => (UrlImg(_ele.osskey, _ele.id)))}
        </div>
      </div>}
      {userInfo?.supplement&&<div className="file-box">
        <h2 className="dotted-line">其他补充资料{userInfo?.supplement?.length&&<span>已上传{userInfo?.supplement?.length}张</span>}</h2>
        <div className="file-list">
          {userInfo?.supplement?.map((_ele: { id: number; osskey: string; }) => (UrlImg(_ele.osskey, _ele.id)))}
        </div>
      </div>}
    </CustomScroll>
    <ImageViewer image={showPreview.url} visible={showPreview.show} onClose={() => { setShowPreview({ show: false }) }} />
  </div>
  )
}

export default memo(FileData);